import OnestockPaymentContainer from "./OnestockPaymentContainer";
import PlanAndPricingStore from "containers/PlanAndPricing/PlanAndPricingStore";

export default PlanAndPricingStore(OnestockPaymentContainer);